
import { useCallback, useState, DragEvent } from 'react';
import { Connection, addEdge } from '@xyflow/react';
import { NodeType } from '../components/NodeExplorer';
import { WorkflowNode, WorkflowEdge, WorkflowNodeData } from '../components/workflow/types';

export function useWorkflowSetup(setEdges: React.Dispatch<React.SetStateAction<WorkflowEdge[]>>, setNodes: React.Dispatch<React.SetStateAction<WorkflowNode[]>>) {
  const [draggedNode, setDraggedNode] = useState<NodeType | null>(null);

  const onConnect = useCallback(
    (connection: Connection) => {
      const newEdge = {
        ...connection,
        animated: true,
        style: { stroke: '#3B82F6' },
        markerEnd: {
          type: 'arrowclosed',
          width: 15,
          height: 15,
          color: '#3B82F6',
        },
      };
      setEdges((eds) => addEdge(newEdge, eds));
    },
    [setEdges]
  );

  // Handle adding a new node from the explorer
  const handleNodeSelect = useCallback((nodeType: NodeType) => {
    setDraggedNode(nodeType);
  }, []);

  // Handle node drop onto the canvas
  const onDrop = useCallback(
    (event: DragEvent<HTMLDivElement>) => {
      event.preventDefault();

      if (!draggedNode) return;

      // Get the position where the node was dropped
      const reactFlowBounds = event.currentTarget.getBoundingClientRect();
      const position = {
        x: event.clientX - reactFlowBounds.left - 100, // Adjust for node width
        y: event.clientY - reactFlowBounds.top - 40,   // Adjust for node height
      };

      // Create a new node with the correct typing
      const newNode: WorkflowNode = {
        id: `node_${Date.now()}`,
        type: 'custom',
        position,
        data: {
          label: draggedNode.label,
          icon: draggedNode.icon,
          description: draggedNode.description,
          category: draggedNode.category
        } as WorkflowNodeData
      };

      setNodes((nds) => [...nds, newNode]);
      setDraggedNode(null);
    },
    [draggedNode, setNodes]
  );

  const onDragOver = useCallback((event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  }, []);

  return {
    draggedNode,
    onConnect,
    handleNodeSelect,
    onDrop,
    onDragOver
  };
}
